import styled from '@emotion/styled';

import { ButtonVariant, ButtonTheme } from '@/styles/themes/button';

import { CoreButton, ICoreButtonProps } from '../CoreButton';

export const GlassButton = styled(CoreButton)<ICoreButtonProps>`
  backdrop-filter: blur(25px);

  &:active,
  &:hover {
    backdrop-filter: blur(6px);
  }
`;

GlassButton.defaultProps = {
  buttonTheme: ButtonTheme.LIGHT,
  variant: ButtonVariant.GLASS,
};
